// 44px tap target around a 24px visual control; controls stack with no gap.
const styles = {
    container: ({revealOnHover}) => ({
        position: 'absolute',
        top: '4px',
        right: '4px',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 2,
        opacity: revealOnHover ? {base: 1, lg: 0} : 1,
        transition: 'opacity 0.2s ease-in-out',
        sx: {
            // :has(:focus-visible) rather than :focus-within so a mouse click doesn't pin them open.
            '[data-video-hover-group]:hover &, &:has(:focus-visible)': {opacity: 1}
        }
    }),
    button: {
        variant: 'unstyled',
        boxSize: '44px',
        minW: '44px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'black',
        cursor: 'pointer',
        borderRadius: 'full',
        _focusVisible: {
            outline: '2px solid',
            outlineColor: 'black',
            outlineOffset: '-8px'
        }
    },
    circle: {
        boxSize: '24px',
        borderRadius: 'full',
        bg: 'whiteAlpha.750',
        backdropFilter: 'blur(2.5px)',
        WebkitBackdropFilter: 'blur(2.5px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    icon: {
        boxSize: '24px'
    }
}

export default styles
